import React from 'react';

export default class Conditions extends React.Component {

    render = () => (
        <div className="genericBody">
            <h2>Conditions générales d'utilisation</h2>
            <h3>Dernière mise à jour: Juillet 2019</h3>
            <span>En utilisant cette application, vous vous portez garant à respecter ses termes d'utilisation et de partage.</span>
            <br/>
            <span>Cette application est libre d'utilisation et pourra être utilisée sur tout support permettant de la lancer.</span>
            <br/>
            <span>Étant libre d'utilisation le partage de cette application est de ce fait aussi gratuit, cependant l'utilisation de cette application à des fins lucratifs pourrait vous exposer à des poursuites judiciaires ainsi qu'à une indemnisation de la société Orca Corp.</span>
            <h3>Transfert des conditions</h3>
            <span>En partageant cette application de manière gratuite, vous vous engagez à ce que les autres utilisateurs respectent eux aussi la politique d'utilisation</span>
            <br/>
            <br/>
            <h3>Orca Corp 2019 ©</h3>
        </div>
    )
}